<template>
  <div id="claim">
    <div class="yto-box search-form y-pb-0">
      <el-form
        ref="searchForm"
        :inline="true"
        :model="form"
        label-width="130px"
      >
      <el-row>
        <el-form-item prop="createTime" label-width="0" class="time-style">
          <el-select v-model="form.queryType" placeholder="活动区域" class="timetype-style">
            <el-option label="发起时间" value="1"></el-option>
            <el-option label="通过时间" value="2"></el-option>
          </el-select>
          <yto-date-picker
            :maxRangeVal="31"
            class="date-style"
            :picker-options="pickerOptions1"
            value-format="yyyy-MM-dd"
            v-model="form.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          ></yto-date-picker>
        </el-form-item>
        <el-form-item prop="indemnityType" label="理赔类型">
          <el-select v-model="form.indemnityType" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in indemnityTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="理赔状态" prop="indemnityStatus">
          <el-radio-group v-model="form.indemnityStatus" size="small" @change="pageChange(1)">
            <el-radio-button label="0">全部 {{statusCount[0] || 0}}</el-radio-button>
            <el-radio-button label="1">待上传凭证 {{statusCount[1] || 0}}</el-radio-button>
            <el-radio-button label="2">待审核 {{statusCount[2] || 0}}</el-radio-button>
            <el-radio-button label="3">审核未通过 {{statusCount[3] || 0}}</el-radio-button>
            <el-radio-button label="4">审核通过 {{statusCount[4] || 0}}</el-radio-button>
            <el-radio-button label="5">取消理赔 {{statusCount[5] || 0}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="运单号" prop="waybillNo">
          <el-input v-model="form.waybillNo" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户编码" prop="customerCode">
          <el-autocomplete
            clearable
            v-model="form.customerCode"
            :fetch-suggestions="querySearch"
            placeholder="请输入"
            @select="handleSelect"
            @clear='clearCustomerCode'
            @input="changeShopCode"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="店铺名称" prop="shopCode">
          <el-select v-model="form.shopCode" filterable placeholder="请选择" clearable>
            <el-option
              v-for="item in shopList"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  style="float:right; margin-right:0">
          <div class="button-group">
            <el-button type="primary" @click="pageChange(1)" icon="el-icon-search">查询</el-button>
            <el-button class="normal-btn" @click="resetForm('searchForm')"><i class="el-icon-refresh-left y-fc-4C84FF"></i>重置</el-button>
            <el-button @click="exportFile" :loading="exportLoading" :disabled="tableLoading || total === 0"><i class="el-icon-download y-fc-4C84FF"></i>导出</el-button>
          </div>
        </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div class="yto-box y-pb-0">
      <div class="mb20">
        <el-button type="primary" class="mr20 copyBtn" @click="handleOrder"><img src="@/assets/images/icon_faqilipei.png"/>发起理赔</el-button>
        <el-tooltip effect="light" placement="bottom-start" class="tooltip-style">
          <div slot="content">
            <span style="color:#666666">理赔状态：待上传凭证、待审核、审核未通过、审核通过、取消理赔；</span><br />
            <span style="color:#666666">待上传凭证：网点发起理赔，需要客户上传物品价值证明，理赔金额；</span><br />
            <span style="color:#666666">待审核：客户发起理赔，需网点审核；</span><br />
            <span style="color:#666666">审核未通过：网点审核为不通过，客户可修改理赔信息后重新提交审核；</span><br />
            <span style="color:#666666">审核通过：网点审核为通过；</span><br />
            <span style="color:#666666">取消理赔：发起理赔后，快件重新找到派送或其他不需要理赔时，网点取消理赔；</span>
          </div>
          <span class="helpInfo"><i class="el-icon-warning systemColor helpIcon mr5" style="cursor: pointer"></i>理赔须知</span>
        </el-tooltip>
        <el-button class="normal-btn setting-btn" @click="openCollectionAccount" :loading='btnLoading'><img src="@/assets/images/icon_shoukuanzhanghu.png"/>设置收款账户</el-button>
      </div>
      <div class="yto-table">
        <el-table :data="tableData" style="width: 100%" v-loading='tableLoading'>
          <el-table-column prop="waybillNo" label="运单号"  align="center"  width="140px">
            <template slot-scope="scope">
              <span class="hilightColor" @click="showWaybillDetail(scope.row)">{{scope.row.waybillNo}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerCode" label="客户编码" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.customerCode">{{scope.row.customerCode}}</span>
              <span v-if="scope.row.customerCode && scope.row.customerName"> - </span>
              <span v-if="scope.row.customerName">{{scope.row.customerName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shopName" min-width="100px" label="店铺名称" align="center"></el-table-column>
          <el-table-column prop="branchName" min-width="100px" label="网点" align="center"></el-table-column>
          <el-table-column prop="indemnityType" label="理赔类型"  align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.indemnityType === '1'">破损</span>
              <span v-if="scope.row.indemnityType === '2'">遗失</span>
              <span v-if="scope.row.indemnityType === '3'">延误</span>
              <span v-if="scope.row.indemnityType === '4'">其他</span>
            </template>
          </el-table-column>
          <el-table-column prop="indemnityStatus" label="理赔状态"  align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.indemnityStatus === '1'">待上传凭证</span>
              <span v-if="scope.row.indemnityStatus === '2'">待审核</span>
              <span v-if="scope.row.indemnityStatus === '3'">审核未通过</span>
              <span v-if="scope.row.indemnityStatus === '4'">审核通过</span>
              <span v-if="scope.row.indemnityStatus === '5'">取消理赔</span>
            </template>
          </el-table-column>
          <el-table-column prop="bigCustomerName" label="物品类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.indemnityGoodsType === '1'">生活用品</span>
              <span v-if="scope.row.indemnityGoodsType === '2'">服饰鞋帽</span>
              <span v-if="scope.row.indemnityGoodsType === '3'">食品</span>
              <span v-if="scope.row.indemnityGoodsType === '4'">文件</span>
              <span v-if="scope.row.indemnityGoodsType === '5'">数码产品</span>
              <span v-if="scope.row.indemnityGoodsType === '6'">其他</span>
            </template>
          </el-table-column>
          <el-table-column prop="indemnityGoodsWorthStr" label="物品价值(元)" align="center"></el-table-column>
          <el-table-column prop="indemnityAmountStr" label="理赔金额(元)" align="center"></el-table-column>
          <el-table-column prop="createTime" label="发起时间" align="center" width="150px"></el-table-column>
          <el-table-column prop="sponsorInfor" label="创建人" align="center"></el-table-column>
          <el-table-column prop="approvedTime" label="审核通过时间" align="center" width="150px"></el-table-column>
          <el-table-column label="操作" width="80px" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleOrder(scope.row)">处理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt20">合计理赔金额：{{allAmout}}元</div>
        <el-pagination
          @size-change="limitChange"
          @current-change="pageChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 走件详情 -->
    <orderTrackingDetails
      :value="showDialog"
      v-if="showDialog"
      :data="orderDetailsData"
      @close="closeDetailInfo"
      ref="orderTrackingDetails"
    ></orderTrackingDetails>
    <handleClaimOrder
      :value="handleClaimDialog"
      v-if="handleClaimDialog"
      :data="handleClaimData"
      @close="closehandleClaim"
      @updataClaimList="updataClaimList"
      ref="handleClaimOrder"
    ></handleClaimOrder>
    <setCollectionAccount
      :value="collectionAccountDialog"
      v-if="collectionAccountDialog"
      :data="collectionAccountData"
      @close="closeCollectionAccount"
      ref="setCollectionAccount"
    ></setCollectionAccount>
    <el-dialog :visible.sync="dialogVisible" title="图片" @close='closeImg' class="imgDialog">
      <div>
        <img width="80%" style="display:block; margin:0 auto" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
    <el-dialog title="提示" center :visible.sync="tipDialogVisible" :close-on-click-modal="false">
      <template>
        <p class="y-fc-000 y-fs-14 y-fl-20 y-mt-0">温馨提示：客户管家【发起的工单】已支持上报理赔，可通过“直通总部-快速理赔”上报。</p>
        <img width="100%" src="@/assets/images/lipei_tipBg.png"/>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeTipDialog">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import netAPI from '@/api';
import { YTOSHORTCUTSDAY, dateFormat, downloadFile } from '@/utils/util';
import handleClaimOrder from './components/handleClaimOrder'; // 发起理赔
import setCollectionAccount from './components/setCollectionAccount'; // 设置理赔账户
import { isGroupAdminApi } from '../../api/universal';
export default {
  components: {
    handleClaimOrder,
    setCollectionAccount
  },
  name: 'claim',
  mixins: [],
  data() {
    return {
      restaurants: [],
      shopList: [],
      pickerOptions1: {
        ...YTOSHORTCUTSDAY,
        disabledDate(time) {
          return (
            time.getTime() > new Date(`${dateFormat(new Date(), 'yyyy-MM-dd')}`).getTime()
          );
        }
      },
      form: {
        queryType: '1',
        createTime: [],
        indemnityType: '',
        indemnityStatus: '0',
        waybillNo: '',
        customerCode: '',
        shopCode: ''
      },
      indemnityTypeList: [
        {code: '1', name: '破损'},
        {code: '2', name: '遗失'},
        {code: '3', name: '延误'},
        {code: '4', name: '其他'}
      ], // 理赔类型:1破损、2遗失、3延误、4其他
      indemnityStatusList: [
        {code: '1', name: '待上传凭证'},
        {code: '2', name: '待审核'},
        {code: '3', name: '审核未通过'},
        {code: '4', name: '审核通过'},
        {code: '5', name: '取消理赔'}
      ], // 理赔状态:1待上传凭证、2待审核、3审核未通过、4审核通过、5取消理赔
      tableData: [],
      allAmout: 0,
      statusCount: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showDialog: false, // 走件物流轨迹
      orderDetailsData: {},
      handleClaimDialog: false, // 处理理赔
      handleClaimData: {},
      collectionAccountDialog: false, // 设置理赔账户
      collectionAccountData: {},
      tableLoading: false,
      dialogImageUrl: '',
      dialogVisible: false,
      btnLoading: false,
      exportLoading: false,
      tipDialogVisible: false,//提示框
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  beforeCreate() {},
  created() {
    this.queryKCodeByIssue();
    let yesterday = new Date(new Date().getTime() - 2 * 24 * 3600000);
    let createTime = [];
    createTime = [
      `${dateFormat(yesterday, 'yyyy-MM-dd')}`,
      `${dateFormat(new Date(), 'yyyy-MM-dd')}`
    ];
    this.$set(this.form, 'createTime', createTime);
  },
  mounted() {
    this.pageChange(1);
  },
  methods: {
    // 发起理赔成功刷新接口
    updataClaimList() {
      this.pageChange(1);
    },
    // 打开发起理赔窗口
    handleOrder(row) {
      if (row && row.id) {
        this.handleClaimDialog = true;//打开理赔弹层
        this.handleClaimData = {
          type: 'deal',
          title: '理赔详情',
          businessNo: row.indemnityNo,
          id: row.id,
          indemnityStatus: row.indemnityStatus,
          branchCode:row.branchCode
        };
      } else {
        this.tipDialogVisible = true;//打开理赔tip弹层
      }
    },
    closeTipDialog(){
      this.tipDialogVisible = false;//关闭理赔tip弹层
      // this.handleClaimDialog = true;//打开理赔弹层
      // this.handleClaimData = {
      //     title: '发起理赔',
      //     type: 'start'
      //   };
    },
    // 关闭发起理赔窗口
    closehandleClaim() {
      this.handleClaimDialog = false;
      // this.currentPage = 1;
      // this.queryIssue();
    },
    // 打开设置理赔账户窗口
    openCollectionAccount() {
      // 判断当前组织下的用户是否为管理员
      this.btnLoading = true;
      isGroupAdminApi({}).then(res => {
        this.btnLoading = false;
        if (res.data) {
          this.collectionAccountDialog = true;
          this.collectionAccountData = {
            // title: '理赔收款账户'
          };
        } else {
          this.$message.error('只有管理员可以设置收款账户');
        }
      }).catch(res => {
        this.btnLoading = false;
        this.$message.error('只有管理员可以设置收款账户');
      });
    },
    // 关闭设置理赔账户窗口
    closeCollectionAccount() {
      this.collectionAccountDialog = false;
      this.currentPage = 1;
      this.queryIssue();
    },
    closeImg() {
      this.dialogImageUrl = '';
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    clearCustomerCode() {
      this.form.customerCode = '';
      this.shopList = [];
      this.form.shopCode = '';
    },
    clearShopCode() {
      this.form.shopCode = '';
    },
    changeShopCode(value) {
      this.shopList = [];
      this.form.shopCode = '';
      let flag = false;
      if (this.form.customerCode) {
        this.restaurants.forEach(r => {
          if (r.value === this.form.customerCode) {
            flag = true;
          }
        });
      }
      if (flag) {
        this.handleSelect({'value': value});
      }
    },
    handleSelect(item) {
      let params = {
        userCode: item.value
      };
      this.shopList = [];
      this.form.shopCode = '';
      netAPI.getShopListClaim(params).then(res => {
        if (res.success) {
          if (res.data && res.data.shopInfoList && res.data.shopInfoList.length) {
            this.shopList = res.data.shopInfoList || [];
          } else {
            this.shopList = [];
          }
        } else {
          this.shopList = [];
        }
      }).catch((err) => {
        this.shopList = [];
        console.log(err);
      });
    },
    queryKCodeByIssue() {
      let params = {
        groupId: this.userMess.groupId,
        loginId: this.userMess.loginId
      };
      this.restaurants = [];
      netAPI.queryKCodeByIssue(params).then(res => {
        if (res.status === 0) {
          if (res.data && res.data.length) {
            res.data.forEach(r => {
              this.restaurants.push({value: r});
            });
          } else {
            this.restaurants = [];
          }
        } else {
          this.restaurants = [];
        }
      }).catch((err) => {
        this.restaurants = [];
        console.log(err);
      });
    },
    // 显示运单号走件物流轨迹窗口
    showWaybillDetail(row) {
      this.showDialog = true;
      this.orderDetailsData = {
        code: row.waybillNo, // 订单号
        title: '走件详情', // dialog头部标题
        isComplaint: false, // 是否为客户投诉模块
        notShowStartOrder: true // 是否不展示一键工单按钮
      };
    },
    // 关闭运单号走件物流轨迹窗口
    closeDetailInfo() {
      this.showDialog = false;
    },
    // 每页条数改变
    limitChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryIssue();
    },
    // 页码改变
    pageChange(val) {
      this.currentPage = val;
      this.queryIssue();
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.queryType = '1';
      this.shopList = [];
      this.$nextTick(()=>{
        this.pageChange(1);
      })
    },
    // 导出已打印
    exportFile() {
      let params = {
        queryType: this.form.queryType,
        startDate: this.form.createTime[0],
        endDate: this.form.createTime[1],
        indemnityType: this.form.indemnityType,
        indemnityStatus: (this.form.indemnityStatus === '0') ? '' : this.form.indemnityStatus,
        waybillNo: this.form.waybillNo,
        customerCode: this.form.customerCode
      };
      if (params.customerCode) {
        params.shopCode = this.form.shopCode || '';
      }
      this.exportLoading = true;
      if (this.total === 0) {
        this.exportLoading = false;
        this.$message.error('当前无数据可导出!');
      } else {
        netAPI.exportMyIndemnity(params).then(res => {
          this.exportLoading = false;
          let blob = new Blob([res]);
          let fileName = '客户管家我的理赔导出.xls';
          downloadFile(blob, fileName);
        }).finally(() => {
          this.exportLoading = false;
        });
      }
    },
    queryIndemnityStatus() {
      let params = {
        queryType: this.form.queryType,
        startDate: this.form.createTime[0],
        endDate: this.form.createTime[1],
        indemnityType: this.form.indemnityType,
        waybillNo: this.form.waybillNo,
        customerCode: this.form.customerCode
      };
      if (params.customerCode) {
        params.shopCode = this.form.shopCode || '';
      }
      netAPI.queryIndemnityStatus(params).then(res => {
        if (res.success && res.data) {
          this.statusCount = res.data || [];
        } else {
          this.statusCount = [];
        }
      }).catch(() => {
        this.statusCount = [];
      });
    },
    // 获取问题件列表
    queryIssue() {
      this.queryIndemnityStatus();
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        queryType: this.form.queryType,
        startDate: this.form.createTime[0],
        endDate: this.form.createTime[1],
        indemnityType: this.form.indemnityType,
        indemnityStatus: (this.form.indemnityStatus === '0') ? '' : this.form.indemnityStatus,
        waybillNo: this.form.waybillNo,
        customerCode: this.form.customerCode
      };
      if (params.customerCode) {
        params.shopCode = this.form.shopCode || '';
      }
      this.tableLoading = true;
      netAPI.getMyIndemnity(params).then(res => {
        let dataList = res.data;
        if (res.success && dataList) {
          this.allAmout = dataList.allAmout ? dataList.allAmout : 0;
          if (dataList.pageInfo) {
            this.tableData = dataList.pageInfo.list || [];
            this.total = dataList.pageInfo.total || 0;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
        this.tableData = [];
        this.total = 0;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../styles/variables';
.hilightColor {
  color: $blue-style;
  cursor: pointer;
}
#claim{
  background-color: #F0F2F8;
  .search-form{
    .el-form-item{
      margin-right: 0;
    }
    /deep/.el-form-item__label{
      padding-right: 8px;
    }
    .timetype-style{
      width: 100px;
    }
    .date-style{
      width: 250px;
      padding: 3px 5px;
      /deep/.el-date-editor .el-range__close-icon{
        display: none;
      }
    }
  }
  .copyBtn span{
    display: inline-flex!important;
    align-items: center;
    img{
      width: 14px;
      vertical-align: text-bottom;
      margin-right: 4px;
    }
  }
  .setting-btn{
    float: right;
    img{
      width: 14px;
      vertical-align: text-bottom;
      margin-right: 4px;
    }
  }
  .helpIcon{
    &::before{
    font-size: 14px;
    }
  }
  .helpInfo{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
}
.mr5 {
    margin-right: 5px;
}
.mr20 {
    margin-right: 20px;
}
.mb20 {
    margin-bottom: 20px;
}
.mt20 {
    margin-top: 20px;
}
.tooltip-style{
    width: 1000px;
}
/deep/.el-form-item{
  .el-form-item__label{
    padding-right: 5px;
  }
}
</style>
